import React, {Component} from 'react';
import SearchDropdown from '../widgets/SearchDropdown';
import fetchJson from '../fetchJson';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import uiActions from '../chrome/ui.actions';
import {push} from 'connected-react-router';
import './CommunitySearchDropdown.css';
import Avatar from '../widgets/Avatar';
import actions from './search.actions';

class CommunitySearchDropdown extends Component {
	constructor(props) {
		super(props);

		this.performSearch = async (query, limit = 5) => {
			try {
				return await fetchJson(
					`/api/search/${encodeURIComponent(query)}?type=community&limit=${limit}`
				);
			} catch (e) {
				this.props.onError();
			}
		};

		this.renderItem = ({
			uuid,
			name,
			profile: {uniqueName, backgroundImage, backgroundPosition = 33} = {},
			location,
			isHighlighted,
			onClick,
			onMouseOver,
			onMouseOut
		}) => {
			return (
				<li
					className={`CommunitySearchDropdown-item ${isHighlighted ? 'highlighted' : ''}`}
					onMouseDown={() => onClick(uniqueName)}
					onMouseOver={() => onMouseOver(uniqueName)}
					onMouseOut={() => onMouseOut(uniqueName)}>
					<Link to={`/!${uniqueName}`}>
						<Avatar size={32} backgroundImage={backgroundImage} />
						<div className="CommunitySearchDropdown-item-name">{name}</div>
						<div className="CommunitySearchDropdown-item-extra">{location && location.suburb}</div>
					</Link>
				</li>
			);
		};

		this.keyFunc = item => item && item.profile && item.profile.uniqueName;
	}

	render() {
		return (
			<SearchDropdown
				className="CommunitySearchDropdown"
				wrapperClassName="CommunitySearchDropdown"
				keyFunc={this.keyFunc}
				onSearch={this.performSearch}
				onSelect={this.props.onSelect}
				itemRenderer={this.renderItem}
				placeholder="Type to search for a community"
				extra={<span className="icon icon-search" />}
				onShowMore={this.props.onShowMore}
				scrollInOnShow={this.props.screenSize === 'mobile'}
				scrollIntoViewElement={this.props.scrollIntoViewElement}
			/>
		);
	}
}

const ConnectedCommunitySearchDropdown = connect(
	({ui}) => ({
		screenSize: ui && ui.screenSize
	}),
	dispatch => ({
		onSelect: uniqueName => dispatch(push('/!' + uniqueName)),
		onShowMore: value => {
			dispatch(actions.searchFor('community'));
			dispatch(push('/search/' + encodeURIComponent(value)));
		},
		onError: () => dispatch(uiActions.uiModal('error'))
	})
)(CommunitySearchDropdown);

export default ConnectedCommunitySearchDropdown;



// WEBPACK FOOTER //
// ./src/search/CommunitySearchDropdown.js